import { BusinessObjectBase } from './base';
import type { Interview } from './interview';

export interface InterviewMotivationData {
  readonly id: number;
  readonly eventKnowledgeScore?: number;
  readonly eventExperienceScore?: number;
  readonly notes?: string;
  readonly interviewId: number;
  readonly interview?: Interview;
}

export interface InterviewMotivation extends Readonly<InterviewMotivationData> {}
export class InterviewMotivation extends BusinessObjectBase {
  static readonly entityName = 'InterviewMotivation' as const;
  static readonly plural = 'interview-motivations';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<InterviewMotivation[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new InterviewMotivation(data));
  }

  static async findOne(filter?: any): Promise<InterviewMotivation | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new InterviewMotivation(data) : null;
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<InterviewMotivation> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new InterviewMotivation(data);
  }

  static async create(
    data: Omit<InterviewMotivationData, 'id'>,
  ): Promise<InterviewMotivation> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new InterviewMotivation(result);
  }

  static async updateById(
    id: number,
    data: Partial<InterviewMotivationData>,
  ): Promise<InterviewMotivation> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new InterviewMotivation(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
